<template>
  <div class="mainDiv">
    <h3>{{ title }}</h3>
    <el-row type="flex" justify="end" style="margin-top: 10px">
      <el-button type="primary" @click="checkAttendance">查看考勤</el-button>
      <el-button type="info" @click="back">返回</el-button>
    </el-row>
    <div class="qrCode_container">
      <div class="title">{{ sign }}二维码</div>
      <img :src="src" class="qrCode" />
      <div class="sign_num">
        {{ sign }}人数:
        <span class="num">{{ signCount }}/{{ total }}</span>
      </div>
      <div class="info">
        <span class="class_time">
          {{ sign }}时间：{{ (signinStarttime * 1000) | datetimeFormat }}——{{
            (signinEndtime * 1000) | datetimeFormat
          }}
        </span>
        <span class="class_hour"> {{ typeName }}课时：{{ tiem }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/attendance/pc'
export default {
  data() {
    return {
      title: '',
      typeName: this.$route.query.typeName,
      sign: this.$route.query.sign,
      type: this.$route.query.type,
      tution: this.$route.query.tution,
      courseId: this.$route.query.courseId,
      courseName: this.$route.query.courseName,
      id: '',
      openTime: '',
      endTime: '',
      signinStarttime: '',
      signinEndtime: '',
      tiem: '',
      src: '',
      params: {
        courseId: '',
        actionType: '',
        type: '',
      },
      total: '',
      signCount: '',
      timer: '',
      timer2: '',
    }
  },
  created() {
    this.getQrCode()
    this.timer2 = setInterval(this.getQrCode, 1000 * 10)
    if (this.sign === '签到') {
      this.getSignRecordCount()
      this.timer = setInterval(this.getSignRecordCount, 1000 * 10)
    } else {
      this.getSignOutRecordCount()
      this.timer = setInterval(this.getSignOutRecordCount, 1000 * 10)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.timer2)
  },
  watch: {
    $route: {
      handler: function (e) {
        const row = JSON.parse(e.query.row)
        this.title = `${row.courseName}（${row.name}）`
        this.id = row.id
        this.openTime = row.openTime
        this.endTime = row.endTime
        this.tiem = row.tiem
        this.params.courseId = row.id
        this.params.actionType = this.sign === '签到' ? '1' : '2'
        this.params.type = this.type
        this.signinStarttime = this.sign === '签到'? row.signinStarttime:row.signoutStarttime
        this.signinEndtime = this.sign === '签到'?row.signinEndtime:row.signoutEndtime
      },
      immediate: true,
    },
  },
  methods: {
    async getQrCode() {
      const { data, code } = (await api.getQrCode(this.params)).data
      if (code === 100000) {
        this.src = data.url
      }
    },

    async getSignRecordCount() {
      const { data, code } = (await api.getSignRecordCount(this.params)).data
      if (code === 100000) {
        this.total = data.total
        this.signCount = data.signCount
      }
    },
    async getSignOutRecordCount() {
      const { data, code } = (await api.getSignOutRecordCount(this.params)).data
      if (code === 100000) {
        this.total = data.total
        this.signCount = data.signOutCount
      }
    },
    checkAttendance() {
      if (this.courseId !== 'undefined' && this.courseName !== 'undefined') {
        this.$router.push(
          `/MyClassroomTutorialsAndLive?type=${this.type}&tution=${this.tution}&courseId=${this.courseId}&courseName=${this.courseName}&curRowId=${this.id}`
        )
      } else {
        this.$router.push(
          `/MyClassroomTutorialsAndLive?type=${this.type}&tution=${this.tution}&curRowId=${this.id}`
        )
      }
    },
    back() {
      if (this.courseId !== 'undefined' && this.courseName !== 'undefined') {
        this.$router.push(
          `/MyClassroomTutorialsAndLive?type=${this.type}&tution=${this.tution}&courseId=${this.courseId}&courseName=${this.courseName}`
        )
      } else {
        this.$router.push(
          `/MyClassroomTutorialsAndLive?type=${this.type}&tution=${this.tution}`
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.qrCode_container {
  text-align: center;
  .title {
    font-size: 20px;
    font-weight: 700;
  }
  .qrCode {
    margin: 20px 0;
    width: 30%;
  }
  .sign_num {
    margin-bottom: 20px;
    font-size: 16px;
    .num {
      color: #449cef;
    }
  }
  .info {
    font-size: 20px;
  }
}
</style>